import { Grid, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import resumeData from "../../utils/resumeDate"
import useStyles from './style';
import Zoom from 'react-reveal/Zoom';


const Home = () => {

  const Progress = ({done}) => {

    const [style, setStyle] = useState({})

    setTimeout(() => {
      const newStyle = {
        opacity: 1,
        width: `${done}%`
      }
      setStyle(newStyle)
    }, 100)
    
    return (
    <div className={classes.progress}>
      <div className={classes.progressDone} style={style} >
        <div className={classes.done}>
        {done}%
        </div>
      </div>
    </div>
  )}

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Zoom>

        {/* About Me */}
        <Grid container className={classes.section}>
        <Grid item className={classes.sectionTitle}>
          <span className={classes.span} />
          <h6 className={classes.sectionTitleText}>About Me</h6>
        </Grid>
          <Grid item xs={12}>
            <Typography
              variant="body1"
              className={classes.aboutmeText}
            >
              {resumeData.about}
            </Typography>
          </Grid>
        </Grid>

        {/* Skills */}
        <Grid container className={classes.section}>
          <Grid item className={classes.sectionTitle}>
            <span className={classes.span} />
            <h6 className={classes.sectionTitleText}>My Skills</h6>
          </Grid>
          <Grid item xs={12} className={classes.skills}>
              <Grid container spacing={5}>
                <Grid item xs={12} lg={5}>
                  <h4>HTML5</h4>
                  <Progress done="90" />
                  <h4>CSS3</h4>
                  <Progress done="90" />
                  <h4>JavaScript</h4>
                  <Progress done="90" />
                  <h4>React</h4>
                  <Progress done="90" />
                  
                </Grid>
                <Grid item xs={12} lg={5}>
                <h4>Material-UI</h4>
                  <Progress done="90" />
                 
                  <h4>NextJs</h4>
                  <Progress done="60" />
                  <h4>Git & Github</h4>
                  <Progress done="80" />
                  <h4>Ui Design</h4>
                  <Progress done="80" />
                </Grid>
              </Grid>
          </Grid>
        </Grid>
        
      </Zoom>
    </div>
  );
};

export default Home;
